import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {SignupService} from "../../../../merchant/services/signup.service";
import {CustomerSignupService} from "../../../services/customer-signup-service";

@Component({
  selector: 'app-customer-email-verification',
  templateUrl: './customer-email-verification.component.html',
  styleUrls: ['./customer-email-verification.component.scss']
})
export class CustomerEmailVerificationComponent implements OnInit{

  token?: string

  constructor(
    public customerSignupService: CustomerSignupService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.customerSignupService.currentStepBs.next(this.customerSignupService.Step.EMAIL_CONFIRMATION);
    this.customerSignupService.disableBackButton = false
    this.customerSignupService.disableNextButton = true // TODO: Change to true

    this.token = this.route.snapshot.params['token'];
    console.log("Received token inside customer-email-verification = ", this.token)
    if (this.token) {
      this.customerSignupService.verifyEmail(this.token)
    }

    // this.currentStepBs.next(Step.SUCCESS);
    // this.currentStepBs.next(Step.FAILED);
  }


}
